const SKIP_STEPS_BY_PARTICIPANT_TYPE = {
  buyer: ["GBDRNFL"],
};

// В кабинете клиента доступны только базовые сервисы по физ./юр. лицам.
const ALLOWED_STEP_CODES = new Set(["GBDFLBasic", "GBDULBasic"]);

export function filterStepsForParticipant(steps, participantTypeCode) {
  if (!Array.isArray(steps)) return [];

  let result = steps.filter((s) => ALLOWED_STEP_CODES.has(s?.code));

  const skip = SKIP_STEPS_BY_PARTICIPANT_TYPE[participantTypeCode];
  if (skip?.length) {
    result = result.filter((s) => !skip.includes(s?.code));
  }
  return result;
}
